"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ConfirmEmail = _interopRequireDefault(require("./ConfirmEmail"));
var _default = exports["default"] = _ConfirmEmail["default"];